import { z } from 'zod';
import { numericEnumValueStrings } from './numeric-enum-value-strings.js';
/** Value must be present and match a numeric @nudool/shared enum's values. */
export const requiredEnumIdString = (enumObject, requiredMessage, invalidMessage) => z.string({ error: requiredMessage }).superRefine((value, context) => {
    if (!value.trim()) {
        context.addIssue({ code: 'custom', message: requiredMessage, path: [] });
        return;
    }
    if (!numericEnumValueStrings(enumObject).has(value)) {
        context.addIssue({ code: 'custom', message: invalidMessage, path: [] });
    }
});
//# sourceMappingURL=required-enum-id-string.js.map